export class AiPunctuateRequestModel {
    indicator: number = 0;
    text: string;
}